import {Registry as CreatorsRegistry} from './eventCreators';

export const analyticsService: AnalyticsService = {
  create(event: AnalyticsEventName, payload?: AnalyticsPayload): ThirdPartyEvent {
    return CreatorsRegistry[event](payload);
  },
};
